<template>
  <div class="transparent-box"><slot></slot></div>
</template>

<script>
export default {
  name: 'TransparentBox'
}
</script>

<style scoped>
.transparent-box {
  background: url('../assets/angled-back.svg') top left no-repeat;
  box-sizing: border-box;
  height: 434px;
  padding-left: 100px;
  padding-top: 50px;
  width: 1040px;
}
</style>